
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'id_tipo_orcamento',
        tipo: 234,
        label: 'Como deseja gerar o Orçamento',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_orc_cp',
        label: 'Selecione o Orçamento para copiar',
        info: '',
        option: {
            key: 'id',
            label: 'ltcat_orcamento',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'descricao',
        maxlength: 255,
        label: 'Descrição',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/orcamento/_form/orcamento-cadastrar.js